export default __webpack_public_path__ + "static/media/lds-logo_ms.6b7bd76308468182.svg";